export default __webpack_public_path__ + "static/media/megavent_product_catalouge.ce89c4d2.pdf";